<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-contact-list', '', '', '')">View Contact List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('create-contact', '', '', '')">Create a Contact</a>
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <component 
                :is="rightView" 
                :prop1="prop1" 
                :prop2="prop2" 
                :prop3="prop3" 
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete"
              >
              </component>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/user-contact-main-store.js'

import userContactList from '../userContactPageComponents/user-contact-list.vue'
import contactCreate from '../utilityComponents/contactComponents/contact-create.vue'


export default {
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllUserContacts();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getAllUserContacts() { this.$store.dispatch("getAllUserContacts"); },
    


    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
        _this.getAllUserContacts();
        _this.changeRightView('user-contact-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
          _this.changeRightView('user-contact-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
  	'user-contact-list': userContactList,
    'create-contact': contactCreate,
  },
  filters: {

  }
}
</script>
